import { subscribe } from './realtime.js';

const controllers = new WeakMap();

function tableApi(table) {
    try {
        return window.jQuery?.fn?.DataTable?.isDataTable(table)
            ? window.jQuery(table).DataTable()
            : null;
    } catch { return null; }
}

function isDisruptive(workspace) {
    return Boolean(
        workspace.querySelector('.modal.show') ||
        workspace.querySelector('tbody input[type="checkbox"]:checked') ||
        workspace.querySelector('[data-realtime-mutation-active="true"]'));
}

function ensureNotice(workspace) {
    let notice = workspace.querySelector('[data-us-realtime-table-notice]');
    if (notice) return notice;
    notice = document.createElement('div');
    notice.className = 'alert alert-info us-realtime-notice';
    notice.dataset.usRealtimeTableNotice = '';
    notice.hidden = true;
    notice.setAttribute('role', 'status');
    const text = document.createElement('span');
    text.textContent = workspace.dataset.usRealtimeChangedLabel || globalThis.UnionStackI18n.text("Common.RealtimeDataChanged");
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'btn btn-sm btn-outline-primary';
    button.textContent = workspace.dataset.usRealtimeRefreshLabel || globalThis.UnionStackI18n.text("Common.Refresh");
    notice.append(text, button);
    workspace.prepend(notice);
    return notice;
}

function enhance(workspace) {
    if (controllers.has(workspace)) return;
    const table = workspace.querySelector('table[data-realtime-topic]');
    const topic = table?.dataset.realtimeTopic;
    if (!table || !topic) return;

    let timer;
    let stale = false;
    const notice = ensureNotice(workspace);
    const button = notice.querySelector('button');
    const reload = () => {
        window.clearTimeout(timer);
        const api = tableApi(table);
        if (!api?.ajax?.reload) {
            stale = true;
            notice.hidden = false;
            return;
        }
        notice.hidden = true;
        stale = false;
        api.ajax.reload(null, false);
    };
    const schedule = () => {
        stale = true;
        window.clearTimeout(timer);
        timer = window.setTimeout(() => {
            if (isDisruptive(workspace)) notice.hidden = false;
            else reload();
        }, 400);
    };
    button.addEventListener('click', reload);
    const unsubscribe = subscribe(topic, type => {
        if (type === 'resource-changed' || type === 'reconnected') schedule();
        if (type === 'subscription-rejected') workspace.dataset.realtimeUnavailable = 'true';
    });
    controllers.set(workspace, { unsubscribe, reload, get stale() { return stale; } });
}

function enhanceAll(root = document) {
    if (root instanceof Element && root.matches('[data-us-datatable-workspace], .data-table-boxed')) enhance(root);
    root.querySelectorAll('[data-us-datatable-workspace], .data-table-boxed').forEach(enhance);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhanceAll(), { once: true });
} else enhanceAll();

new MutationObserver(mutations => {
    for (const mutation of mutations) {
        for (const node of mutation.addedNodes) if (node instanceof Element) enhanceAll(node);
    }
}).observe(document.documentElement, { childList: true, subtree: true });

export { enhance as enhanceRealtimeDataTable, enhanceAll as enhanceRealtimeDataTables };
